<template>
	<div id="header" class="fixed-top bg-white">

		<div class="header-container">
			<!-- Slim Header - stile AGID -->
			<div class="it-header-slim-wrapper" :class="{ 'scrolled': false }">
				<div class="container-xxl">
					<div class="row">
						<div class="col-12">
							<div class="it-header-slim-wrapper-content">
								<div class="d-flex align-items-center">
									<div class="ministry-title navbar-brand p-0">
										Ministero delle infrastrutture e dei trasporti
									</div>

									<a href="https://www.mit.gov.it/" target="_blank" rel="noopener noreferrer"
										class="ms-2">
										<svg class="icon mb-1" aria-hidden="true">
											<use
												:href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-external-link"'>
											</use>
										</svg>
									</a>
								</div>
								<!--<a class="navbar-brand p-0" href="https://www.governo.it/it">
								Ministero delle infrastrutture e dei trasporti
								<svg class="icon" aria-hidden="true">
									<use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-external-link"'></use>
								</svg>
							</a>-->

								<div class="header-slim-right d-flex align-items-center">
									<UserSection class="me-2" />
									<!--<a class="btn" href="https://www.serviziocontrattipubblici.org/Home/contatti">
									Contatti
								</a>-->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--<div class="it-nav-wrapper">
				<div class="it-header-center-wrapper">
					<div class="container-xxl">
						<div class="row">
							<div class="col-12">
								<div class="it-header-center-content-wrapper">
									<div class="it-brand-wrapper">
										<a href="#">
											<img :src="logo" alt="Logo Supporto Giuridico" class="custom-logo" />
											<div class="it-brand-text">
												<div class="it-brand-title">Supporto Giuridico</div>
											</div>
										</a>
									</div>
									<div class="it-right-zone">
										<div class="it-ministry-text text-end">
											<p class="mb-0">Ministero delle infrastrutture e dei<br>trasporti</p>
											<p class="mb-0">Dipartimento per gli affari generali e la digitalizzazione
											</p>
											<p class="mb-0">Direzione generale per gli affari legali, societari e
												i<br>contratti pubblici</p>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="it-subheader-bar">
					<div class="subheader-content">
						<div class="subheader-stripe"><img src="../../assets/BandieraItaliana.png" alt="Collaborazione" class="subheader-logo" /></div>
						<span class="subheader-text">
							in collaborazione con la Conferenza delle Regioni e Province Autonome e ITACA
						</span>
					</div>
				</div>
			</div>-->
			<div class="it-nav-wrapper">
				<div class="it-header-center-wrapper">
					<div class="container-xxl">
						<div class="row">
							<div class="col-12">
								<div class="it-header-center-content-wrapper">
									<div class="it-brand-wrapper">
										<a href="#">
											<img src="../../assets/logocp.png" alt="Logo Supporto Giuridico"
												class="custom-logo" />
											<div class="it-brand-text">
												<div class="it-brand-title">Supporto Giuridico</div>
											</div>
										</a>
									</div>

									<!--<div class="it-right-zone">
										<div class="it-ministry-text text-end">
											<p class="mb-0">Ministero delle infrastrutture e dei<br>trasporti</p>
											<p class="mb-0">Dipartimento per gli affari generali e la digitalizzazione
											</p>
											<p class="mb-0">Direzione generale per gli affari legali, societari e
												i<br>contratti pubblici</p>
										</div>
									</div>-->

									<div class="it-right-zone">
										<div class="it-ministry-text text-end">
											<p class="mb-0">In collaborazione con la Conferenza delle Regioni <br>e
												Province Autonome e ITACA</p>
											<!--<p class="mb-0">Dipartimento per gli affari generali e la digitalizzazione
											</p>
											<p class="mb-0">Direzione generale per gli affari legali, societari e
												i<br>contratti pubblici</p>-->
										</div>
									</div>

								</div>
								<!--<div class="it-info-text">
									<p class="mb-0">in collaborazione con la Conferenza delle Regioni e Province
										Autonome e ITACA</p>
								</div>-->
							</div>
						</div>
					</div>
				</div>
				<!--<div class="it-subheader-bar">
				</div>-->
			</div>
			<div v-if="!$root.user" class="header-nav-bar">
				<div class="header-nav-bar-inner">
					<a class="header-nav-link" href="https://www.serviziocontrattipubblici.it/" target="_blank">
						Home
					</a>
					<a class="header-nav-link" :class="{ active: $root.activePreLoginView === 'PareriHighlighted' }"
						@click="$root.changeView($root.views.PareriHighlighted); $root.activePreLoginView = 'PareriHighlighted'">
						Pareri in evidenza
					</a>
					<a class="header-nav-link"
						:class="{ active: $root.activePreLoginView === 'ListaPareriConsultabili' }"
						@click="$root.changeView($root.views.ListaPareriConsultabili); $root.activePreLoginView = 'ListaPareriConsultabili'">
						Consultazione Pareri
					</a>
					<a class="header-nav-link" :class="{ active: $root.activePreLoginView === 'HelpDeskPnrr' }" @click="
						$root.listaPareriPresetFilters = {
							filterId: '',
							filterText: 'pnrr',
							selectedTopics: [],
							selectedArticles: []
						};

					$root.changeView($root.views.HelpDeskPnrr);
					$root.activePreLoginView = 'HelpDeskPnrr';
					">
						Help Desk Appalti PNRR e PNC
					</a>
					<a class="header-nav-link" :class="{ active: $root.activePreLoginView === 'HomeView' }"
						@click="$root.changeView($root.views.HomeView); $root.activePreLoginView = 'HomeView'">
						Accesso al Servizio
					</a>
				</div>
			</div>
			<div class="it-subheader-bar">
			</div>
		</div>
	</div>
</template>

<style scoped>
.header-nav-bar {
	background: #fff;
	border-top: 1px solid #e6e6e6;
	padding: 0;
}

.header-nav-bar-inner {
	display: flex;
	gap: 0;
	padding: 0 1rem;
}

.header-nav-link {
	display: inline-block;
	padding: 0.75rem 1.5rem;
	font-size: 1rem;
	font-weight: 600;
	color: #0066cc;
	text-decoration: none;
	cursor: pointer;
	transition: background-color 0.2s, color 0.2s;
	border: none;
}

.header-nav-link:hover,
.header-nav-link.active {
	background-color: #0066cc;
	color: #fff;
}

.fixed-top {
	top: 0;
	right: 0;
	left: 0;
	z-index: 1030;
	position: absolute !important;
}

.mobile-menu {
	display: flex;
	height: calc(100vh);
	flex-direction: column !important;
}

.mobile-menu>a {
	margin-top: 1.4em;
	margin-left: 2em;
	flex-grow: 0;
	transition: opacity 0.3s ease-in-out 0s, color 0.3s ease-in-out 0s, background-color 0.3s ease-in-out 0s, text-decoration 0.3s ease-in-out 0s, top 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s, bottom 0.3s ease-in-out 0s, left 0.3s ease-in-out 0s, width 0.3s ease-in-out 0s, max-width 0.3s ease-in-out 0s, height 0.3s ease-in-out 0s, max-height 0.3s ease-in-out 0s, padding-top 0.3s ease-in-out 0s, padding-right 0.3s ease-in-out 0s, padding-bottom 0.3s ease-in-out 0s, padding-left 0.3s ease-in-out 0s, box-shadow 0.3s ease-in-out 0s, border-color 0.3s ease-in-out 0s, transform 0.3s ease-in-out 0s;
}

.mobile-menu>a:hover {
	border-left: 2px solid #003366;
	background-color: transparent;
	color: #0066cc;
	margin-left: calc(2em - 2px);
}

.menu-link {
	color: #0066cc;
	font-weight: bold;
	text-decoration: none;
	transition: opacity 0.3s ease-in-out 0s, color 0.3s ease-in-out 0s, background-color 0.3s ease-in-out 0s, text-decoration 0.3s ease-in-out 0s, top 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s, bottom 0.3s ease-in-out 0s, left 0.3s ease-in-out 0s, width 0.3s ease-in-out 0s, max-width 0.3s ease-in-out 0s, height 0.3s ease-in-out 0s, max-height 0.3s ease-in-out 0s, padding-top 0.3s ease-in-out 0s, padding-right 0.3s ease-in-out 0s, padding-bottom 0.3s ease-in-out 0s, padding-left 0.3s ease-in-out 0s, box-shadow 0.3s ease-in-out 0s, border-color 0.3s ease-in-out 0s, transform 0.3s ease-in-out 0s
}

.menu-link:hover {
	text-decoration: underline;
	background-color: #0066cc;
	color: #FFF;
}

.title {
	font-weight: 700;
	font-style: 'normal';
	color: #0066cc;
}

.ministry-title {
	font-weight: 400;
	font-style: 'normal';
	font-size: 1rem !important;
	font-size: medium;
	color: #0066cc;
}

h1.title {
	font-size: 37px;
}

.it-header-slim-wrapper {
	background-color: #003366
}

.it-header-slim-wrapper-content>a {
	font-size: 16px;
}

.contact-link {
	position: relative;
	top: -3px
}

.it-nav-wrapper {
	min-height: 15rem;

}

.it-header-center-wrapper {
	background: white;
	height: 15rem;
	padding-left: 0;
	padding-right: 0;
	padding-top: 6px;
}

.it-header-center-wrapper-blue {
	background: radial-gradient(circle at center, #0099ff, #003399);
	height: 15rem;
	padding-left: 0;
	padding-right: 0;
	padding-top: 6px;
}

.it-ministry-text p {
	font-weight: 700;
	/**font-size: 0.95rem;*/
	font-size: 0.95rem;
	margin-bottom: 0.25rem;
	text-align: left;
	color: #4169E1;
}

.it-info-text p {
	font-weight: 700;
	/**font-size: 0.95rem;*/
	font-size: 1.1rem;
	margin-bottom: 0.25rem;
	text-align: center;
	color: #4169E1;
}

.it-ministry-text p:first-child {
	font-size: 1.3rem;
	/** 1.3 1.5 1.7 */
	text-align: left;
}

.it-brand-title {
	font-size: 2.8rem !important;
	font-weight: 700 !important;
	color: #4169E1;
}

/**.it-subheader-bar {
	width: 100%;
	height: 3rem;
	background-color: #1E90FF;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 0 1rem;
}*/

.it-subheader-bar {
	width: 100%;
	height: 0.4rem;
	background-image: url('../../assets/BandieraItaliana.png');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	padding: 0;
	margin: 0;
}

.it-subheader-bar .subheader-text {
	color: white;
	font-weight: 600;
	font-size: 1rem;
}

@media (max-width: 768px) {
	.it-subheader-bar {
		min-height: 4rem;
	}

	.it-subheader-bar .subheader-text {
		font-size: 0.9rem;
	}
}

@media (max-width: 480px) {
	.it-subheader-bar .subheader-text {
		font-size: 0.8rem;
	}
}

.header-container {
	max-width: 100%;
	margin: 0 auto;
	/* centra */
	box-shadow: 0 4px 10px rgba(0, 102, 204, 0.3);
}

@media (max-width: 1200px) {
	.header-container {
		max-width: 90%;
	}
}

@media (max-width: 768px) {
	.header-container {
		max-width: 95%;
	}
}

/**.subheader-logo {
	margin-top: -1.1rem;
	display: block;
	//height: auto;
	height:0.4rem;
	width:119rem;
}*/

.custom-logo {
	height: 10rem;
	width: auto;
	object-fit: contain;
	/**margin-right: 4rem;*/
	margin-right: 1rem;
	scale: 0.75;
}

.subheader-text {
	position: relative;
	top: 0.5rem;
}
</style>

<script>

import UserSection from "../partials/UserSection.vue";
import logo from "../../assets/logo.png"; //
//import bandiera from "../../assets/BandieraItaliana.png";

export default {
	name: "HeaderTemplate",
	components: {
		UserSection
	},
	data: () => {
		return {
			openMenu: false,
			logo: logo,
			//bandiera: bandiera
		}
	},
	props: {},
	methods: {
		checkWidth() {
			if (document.documentElement.clientWidth > 767) {
				this.openMenu = false;
			}
		}
	},
	mounted() {
		this.checkWidth();
		window.addEventListener("resize", this.checkWidth);

		// Watch for changes in the root component's breadcrumbData
		this.$watch(
			() => this.$root.breadcrumbData,
			() => {
				// Force component update when breadcrumbData changes
				this.$forceUpdate();
			},
			{ deep: true }
		);
	},
	unmounted() {
		window.removeEventListener("resize", this.checkWidth);
	}
}

</script>
